"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidStrategyRequestToJSON = exports.BidStrategyRequestFromJSONTyped = exports.BidStrategyRequestFromJSON = exports.BidStrategyRequest = void 0;
/**
 * Strategy for how bids will be applied in the auction.
 *  - "MAX_BID": the bid_micro_amount will act as a bid cap, meaning the maximum amount paid
 * per 1000 impressions.
 *
 * @export
 */
exports.BidStrategyRequest = {
    CostPerResult: 'COST_PER_RESULT',
    MaxBid: 'MAX_BID',
    Unset: 'UNSET'
};
function BidStrategyRequestFromJSON(json) {
    return BidStrategyRequestFromJSONTyped(json, false);
}
exports.BidStrategyRequestFromJSON = BidStrategyRequestFromJSON;
function BidStrategyRequestFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BidStrategyRequestFromJSONTyped = BidStrategyRequestFromJSONTyped;
function BidStrategyRequestToJSON(value) {
    return value;
}
exports.BidStrategyRequestToJSON = BidStrategyRequestToJSON;
